import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/lang";

const ITEMS = ["headshots", "showreel", "ueber", "vita", "profil", "kontakt"];

export const Navbar = () => {
  const { lang, setLang, copy } = useLanguage();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const lenis = window.__lenis;
    const el = document.getElementById(id);
    if (lenis && el) lenis.scrollTo(el, { offset: -20 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  const renderLangToggle = (testid) => (
    <button
      data-testid={testid}
      onClick={() => setLang(lang === "de" ? "en" : "de")}
      className="text-xs uppercase tracking-[0.2em] border border-white/20 px-3 py-1.5 text-zinc-400 hover:text-white hover:border-white/60 transition-[color,border-color] duration-300"
    >
      {lang === "de" ? "EN" : "DE"}
    </button>
  );

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-black/60 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("top")}
          className="font-display text-xl md:text-2xl tracking-tight italic hover:opacity-70 transition-opacity duration-300"
        >
          Clive Bucher
        </button>

        <div className="hidden md:flex items-center gap-8">
          <nav className="flex items-center gap-8">
            {ITEMS.map((id) => (
              <button
                key={id}
                data-testid={`nav-link-${id}`}
                onClick={() => go(id)}
                className="text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors duration-300"
              >
                {copy.nav[id]}
              </button>
            ))}
          </nav>
          {renderLangToggle("nav-lang-toggle")}
        </div>

        <div className="md:hidden flex items-center gap-4">
          {renderLangToggle("nav-lang-toggle-mobile")}
          <button
            data-testid="nav-mobile-toggle"
            className="text-white"
            onClick={() => setOpen(!open)}
            aria-label="Menü"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-black/90 backdrop-blur-xl border-b border-white/10 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {ITEMS.map((id) => (
                <button
                  key={id}
                  data-testid={`nav-mobile-link-${id}`}
                  onClick={() => go(id)}
                  className="text-left text-sm uppercase tracking-[0.25em] text-zinc-300 hover:text-white transition-colors duration-300"
                >
                  {copy.nav[id]}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
